import { FC } from 'react';
import { SingleValueProps, GroupBase, components } from 'react-select';

import { ChainsEnum } from '@/config';
import { getIconByNetwork } from '@/helpers';
import { SelectOption } from '../models';

import styles from './SingleValueChain.module.sass';

const { SingleValue } = components;

export type SingleValueChainProps = SingleValueProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
>;

const SingleValueChain: FC<SingleValueChainProps> = (props) => {
  const { children, ...restProps } = props;
  const { data } = restProps;
  const { label, value } = data;

  const iconSrc = getIconByNetwork(value);

  const abbr = value !== ChainsEnum.TETHER_OMNI ? value : 'USDT';

  return (
    <SingleValue {...restProps}>
      <div className={styles.single}>
        <div className={styles.icon}>
          <img src={iconSrc} alt={label} />
        </div>
        <div className={styles.info}>
          <div className={styles.label}>{label}</div>
        </div>
        <div className={styles.abbr}>{abbr}</div>
      </div>
    </SingleValue>
  );
};

export default SingleValueChain;
